import api from './client'

// SISTEMA → Cazador: las tandas 1:1 del cazador de fidelización (Opus).
export const fidelizacionApi = {
  tandas: ()      => api.get('/marketing/fidelizacion/tandas'),
  presas: (params) => api.get('/marketing/fidelizacion/presas', { params }),
  presa:  (id)    => api.get(`/marketing/fidelizacion/presas/${id}`),
  // "Esa compra no fue por el mail": saca la NV de la atribución para siempre.
  descartarAtribucion: (id) => api.post(`/marketing/fidelizacion/presas/${id}/descartar-atribucion`),
}
